import '../styles/DevelopedBy.css';

function DevBy() {
    const year = new Date().getFullYear();
    return (
        <div className="developed-by">
            <p className="developed-rights">© {year} EF Jasna Abuzaid. Alla rättigheter förbehållna.</p>
            <p className="developed-credit">
                Denna sida är fullt utvecklad av{' '}
                <a
                    href="https://www.ithjalparna.se"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ith-brand"
                    aria-label="IT-hjälparna"
                >
                    <span className="ith-chevron" aria-hidden="true">&gt;</span>
                    <span className="ith-it">IT</span>
                    <span className="ith-suffix">-hjälparn</span>
                    <span className="ith-blink-a">a</span>
                </a>
                .
            </p>
            <p>
                <a href="https://www.ithjalparna.se" target="_blank" rel="noopener noreferrer">
                    www.ithjalparna.se
                </a>
            </p>
        </div>
    );
}

export default DevBy;